export default () => ({
    tenantsList: []
})
